/* eslint-disable */

import TableScreen from "@/lib/components/table/TableScreen";

export default class Indicadores extends TableScreen {

    constructor(store) {

        //Nome do model

        super('indicadores', 'aqui_vai_o_endpoint_do_export');

        this.$store = store;

        //aqui os campos que serão exibidos no header do grid
        this.headerDx = [

            { caption: "Título", dataField: "title", dataType: "string" },
            { caption: "Largura", dataField: "width", dataType: "number" },
            { caption: "Altura", dataField: "height", dataType: "number" },
            { caption: "Link", dataField: "src", dataType: "string" },
        ];

        this.defaultItem = {};

        this.editedItem = {};

        //Título da tela

        this.title = 'Indicadores';
        this.keyField = "id";
    }

}